var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
    fill: "white",
    fillOpacity: 0.12
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6303 20.3083C28.0414 20.7194 28.0414 21.3859 27.6303 21.797L21.797 27.6303C21.3859 28.0414 20.7194 28.0414 20.3083 27.6303C19.8972 27.2192 19.8972 26.5527 20.3083 26.1416L26.1416 20.3083C26.5527 19.8972 27.2192 19.8972 27.6303 20.3083Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3083 20.3083C20.7194 19.8972 21.3859 19.8972 21.797 20.3083L27.6303 26.1416C28.0414 26.5527 28.0414 27.2192 27.6303 27.6303C27.2192 28.0414 26.5527 28.0414 26.1416 27.6303L20.3083 21.797C19.8972 21.3859 19.8972 20.7194 20.3083 20.3083Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0001 32.9475C28.9416 32.9475 32.9475 28.9416 32.9475 24.0001C32.9475 19.0586 28.9416 15.0527 24.0001 15.0527C19.0586 15.0527 15.0527 19.0586 15.0527 24.0001C15.0527 28.9416 19.0586 32.9475 24.0001 32.9475ZM35.0527 24.0001C35.0527 30.1043 30.1043 35.0527 24.0001 35.0527C17.8959 35.0527 12.9475 30.1043 12.9475 24.0001C12.9475 17.8959 17.8959 12.9475 24.0001 12.9475C30.1043 12.9475 35.0527 17.8959 35.0527 24.0001Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.cdd708cf677fdaa77b01c708b9bb9c56.svg";
export { ForwardRef as ReactComponent };